import { Badge } from '@airbus/components-react';
import { Notifications } from '@mui/icons-material';
import styles from './header.module.css';

type Props = {
  count: number;
  extraCount?: number;
  iconSize?: number;
  className?: string;
};

export default function NotificationsCount({
  count,
  extraCount = 0,
  iconSize = 20,
  className,
}: Props) {
  const totalCount = count + extraCount;
  return (
    <div className={`${styles.notificationdiv} ${className ?? ''}`}>
      {totalCount > 0 ? (
        <>
          <Badge count={totalCount} variant='error' className={styles.notificationbadge} />
          <Notifications className={styles.notificationsicon} />
        </>
      ) : (
        <Notifications
          style={{ width: iconSize, height: iconSize }}
          className={styles.notificationsicon}
        />
      )}
    </div>
  );
}
